import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getAdminSavedInstallmentsSummaryService } from '@http/adminMetricsService'
import { Role } from '@types'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { userProfile } from '@views/profile/state/profileSlice'
import { getErrorMessage } from '@officeTimeTracker/utils/timeTrackerUi'
import { AdminSavedInstallmentsFilters, AdminSavedInstallmentsSummary } from '../types'

const EMPTY_SUMMARY: AdminSavedInstallmentsSummary = {
  savedInstallments: 0,
  savedTaxes: 0,
  totalCases: 0,
  successCases: 0
}

const useAdminSavedInstallmentsMetrics = (filters: AdminSavedInstallmentsFilters, enabled = true) => {
  const { cocap } = useSelector(selectCredentials)
  const { role } = useSelector(userProfile)
  const [summary, setSummary] = useState<AdminSavedInstallmentsSummary>(EMPTY_SUMMARY)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!enabled || role !== Role.admin || !cocap) {
      return undefined
    }

    let isMounted = true

    const loadSummary = async () => {
      setLoading(true)
      setError(null)

      try {
        const response = await getAdminSavedInstallmentsSummaryService(cocap, filters)

        if (!isMounted) {
          return
        }

        setSummary({
          savedInstallments: Number(response.savedInstallments || 0),
          savedTaxes: Number(response.savedTaxes || 0),
          totalCases: Number(response.totalCases || 0),
          successCases: Number(response.successCases || 0)
        })
      } catch (loadError) {
        if (!isMounted) {
          return
        }

        setSummary(EMPTY_SUMMARY)
        setError(getErrorMessage(loadError, 'No se pudo cargar el resumen de cuotas ahorradas.'))
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    void loadSummary()

    return () => {
      isMounted = false
    }
  }, [cocap, enabled, filters, role])

  return {
    error,
    loading,
    summary
  }
}

export default useAdminSavedInstallmentsMetrics
